const WORKER_URL = import.meta.env.VITE_WORKER_URL ?? "http://localhost:8787";

// Movies come from OMDb through the worker (design_documents/movies-category.md).
// The worker already absorbs OMDb's quirks ("N/A" → null, prose dates → ISO,
// HTTP-200 errors → real status codes), so this is the same thin client as the
// other sources. A 429 means the daily OMDb quota ran out — callers show a toast.

async function request(path, { signal } = {}) {
	const resp = await fetch(`${WORKER_URL}${path}`, { signal });
	if (!resp.ok) {
		let message = `Request failed: ${resp.status}`;
		try {
			const body = await resp.json();
			if (body?.error) message = body.error;
		} catch {
			// non-JSON body, keep default message
		}
		const err = new Error(message);
		err.status = resp.status;
		throw err;
	}
	return resp.json();
}

// Title search (max 10 rows: imdb_id, title, release_year, cover_url). A query
// that is an IMDb id or an IMDb URL is looked up directly and comes back as the
// single result — the escape hatch for OMDb's exact-substring title search.
export function searchMovies(query, { signal } = {}) {
	const params = new URLSearchParams({ q: query });
	return request(`/movies/search?${params}`, { signal });
}

// The full record for one film (plot, runtime, genres, people, rating…).
export function getMovie(imdbId, { signal } = {}) {
	return request(`/movie/${encodeURIComponent(imdbId)}`, { signal });
}

// The film series a movie belongs to (Wikidata): [{ series_id, name, films:
// [{ imdb_id, title, year, order }] }], tightest series first.
export function getMovieSeries(imdbId, { signal } = {}) {
	return request(`/movie/${encodeURIComponent(imdbId)}/series`, { signal });
}
